import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-12 md:grid-cols-6 grid-cols-1 gap-2 w-full items-center py-4 my-0" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"lg:col-span-4 md:col-span-4 col-span-12 flex flex-row\"><span class=\"text-left font-bold md:hidden mr-2\">Pessoa/Grupo com Acesso:</span><p class=\"md:text-left\">Ezequiel</p></div><div class=\"lg:col-span-4 md:col-span-4 col-span-12 flex flex-row\"><span class=\"text-left font-bold md:hidden mr-2\">E-mail:</span><p class=\"md:text-left truncate\">ezequiel.campos@boasnovasgestao.com.br</p></div>", 2)
const _hoisted_4 = { class: "lg:col-span-4 md:col-span-4 col-span-12 flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Nível de acesso:", -1)

import { ref } from 'vue'

interface PermissionOption {
  label: string
  value: string
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableAccessManager',
  setup(__props) {

const permissionsForSelect = ref<PermissionOption[]>([
  { label: 'Proprietário', value: 'owner' },
  { label: 'Visualizar informações', value: 'info' },
  { label: 'Editar informações', value: 'edit' },
  { label: 'Administrador', value: 'admin' }
])

const subject = ref({
  name: 'Ezequiel',
  email: 'ezequiel.campos@boasnovasgestao.com.br',
  resource_relation: 'info'
})

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_v_select, {
          modelValue: subject.value.resource_relation,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subject.value.resource_relation) = $event)),
          items: permissionsForSelect.value,
          "item-title": "label",
          "item-value": "value",
          color: "primary20",
          density: "compact",
          variant: "plain"
        }, {
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _mergeProps(props, {
              disabled: item.raw.disabled
            }), null, 16, ["disabled"])
          ]),
          _: 1
        }, 8, ["modelValue", "items"])
      ])
    ])
  ]))
}
}

})